import axios from "axios";
import roles from "@/components/constants/roles";

export function classifiersGet(searchData) {
    return axios.post(`classifiers`, searchData)
}

export function getFileSetting() {
    axios.get('fileTypes').then((response => {
        const fileTypes = JSON.stringify(response.data.file_types);
        const maxSize = JSON.stringify(response.data.max_file_size);
        sessionStorage.setItem('file_types', fileTypes);
        sessionStorage.setItem('max_file_size', maxSize);
        return { file_types: fileTypes, max_file_size: maxSize };
    }));
}

export function getNoticeSearchListByRole() {
    let userRole = this.$store.getters.userRole
    let notarialRoles = roles.NOTARINIU_GRUPE;
    if(this.$route.name == "errorsCorrectionList"){
        return this.enumsClassifiers.msgErrorsCorrectionType
    }
    if (userRole.some(role => notarialRoles.includes(role))) {
        let hideKeys = ['[403]','[404]','[405]','[406]', '[424,425]', '[426,427]', '[428,429]', '[430,411]']
        hideKeys.map(key =>{
            delete this.enumsClassifiers.msgType.lt[key]
            delete this.enumsClassifiers.msgType.en[key]
        })
    } else {
        let hideKeys = ['[401]','[402]','[403]','[404]','[405]','[406]', '[424]']
        hideKeys.map(key =>{
            delete this.enumsClassifiers.msgType.lt[key]
            delete this.enumsClassifiers.msgType.en[key]
        })
    }
    return this.enumsClassifiers.msgType
}